interface IArgs {
    stage: string;
    delay?: number;
    onRest?(): void;
    immediate?: boolean;
}

export function getFadeInOutProps(config: IArgs) {
    const { stage, delay, onRest, immediate } = config;

    return {
        from: {
            opacity: stage === 'enter' ? 0 : 1,
        },
        to: {
            opacity: stage === 'exit' ? 0 : 1,
        },
        config: {
            duration: 100,
        },
        delay,
        onRest,
        immediate,
    };
}
